import { render, staticRenderFns } from "./FormularioSala.vue?vue&type=template&id=f3c9116c"
import script from "./FormularioSala.vue?vue&type=script&lang=js"
export * from "./FormularioSala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports